import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

export function getPaginatorIntl(translate: TranslateService) {
  const paginatorIntl = new MatPaginatorIntl();

  const translateLabels = () => {
    paginatorIntl.itemsPerPageLabel = translate.instant('COMMON.ITEMS_PER_PAGE');
    paginatorIntl.nextPageLabel = translate.instant('COMMON.NEXT_PAGE');
    paginatorIntl.previousPageLabel = translate.instant('COMMON.PREVIOUS_PAGE');
    paginatorIntl.firstPageLabel = translate.instant('COMMON.FIRST_PAGE');
    paginatorIntl.lastPageLabel = translate.instant('COMMON.LAST_PAGE');
    paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
      if (length === 0 || pageSize === 0) {
        return translate.instant('COMMON.RANGE_EMPTY', { length });
      }
      const startIndex = page * pageSize;
      const endIndex = startIndex < length
        ? Math.min(startIndex + pageSize, length)
        : startIndex + pageSize;
      return translate.instant('COMMON.RANGE', {
        start: startIndex + 1,
        end: endIndex,
        length
      });
    };
    paginatorIntl.changes.next();
  };

  // inicializa
  translateLabels();

  // se actualiza si cambias de idioma
  translate.onLangChange.subscribe(() => translateLabels());

  return paginatorIntl;
}
